import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'
import { CrncyRateModel, CstSubTotalModel } from '../../../../services/index';
import * as bigdecimal from 'bigdecimal';
import { Util } from '../../../../utils/index'


@Component({
    selector:'fare-rate-detail-sum',
    templateUrl: 'fare-rate-detail-sum.html',
    inputs: ['fareTypeNm', 'cnsltnReq']
})


export class FareRateDetailSum implements OnInit {
  crncyCdList:Array<any> = new Array<any>();
  _crncyRateList: Array<CrncyRateModel> = [];
  _cstSubTotalList:Array<CstSubTotalModel>;
  currencyFormat:Function = Util.currencyFormat;

  getCrncyCd(index: number) {
    if (!this._cstSubTotalList[index].crncyCd) return null;
    else return [this._cstSubTotalList[index].crncyCd];
  }

  @Input() set cstSubTotalList(cstSubTotalList:Array<CstSubTotalModel>){
    if(!cstSubTotalList) return;
    this._cstSubTotalList = cstSubTotalList;
    for(let i=0;i<this._cstSubTotalList.length;i++){
      this.refreshValue(this._cstSubTotalList[i].crncyCd,i);
    }
  }

  @Input() set crncyRateList(crncyRateList:Array<CrncyRateModel>){
    if(!crncyRateList)return;
    this._crncyRateList = crncyRateList;
    crncyRateList.map((crncyRate:CrncyRateModel) => {
      this.crncyCdList.push({id: crncyRate.crncyCd, text: crncyRate.crncyCd});
    });
  }
  
  @Output() changeCrncy: EventEmitter<any> = new EventEmitter();
  
  constructor(){
  }

  ngOnInit(){
  }

  public refreshValue(value: any, index:number):void {
    if(!this._cstSubTotalList || this._cstSubTotalList.length <= 0) return;
    this._cstSubTotalList[index].crncyCd = (typeof value === 'string') ? value : value.id;

    let crncyRateIndex = this._crncyRateList.findIndex(crncyRate => this._cstSubTotalList[index].crncyCd == crncyRate.crncyCd);
    if (crncyRateIndex >= 0) {
      let crncyRate = this._crncyRateList[crncyRateIndex];
      let krwPerUnit = new bigdecimal.BigDecimal(crncyRate.krwPerUnit);
      this._cstSubTotalList[index].temp = "기준환율 : " + Util.numberWithCommas(krwPerUnit.setScale(2, bigdecimal.RoundingMode.DOWN()).doubleValue()) +
        " KRW (기준일 : " + Util.dateFomatter(crncyRate.stndDt)+")"; 
    }

    this.changeCrncy.emit(index);
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/fare/rate/detail/fare-rate-detail-sum.ts